import ApiUtils from '@/utils/api/ApiUtils'
import C1301Const from './C1301Const'

const store = {
  state: {
    cities: [],
    states: [],
    countries: [],
    tierInfo: {},
    shippingInfoCountries: null
  },
  getters: {
    getCities: (state) => state.cities,
    getStates: (state) => state.states,
    getCountries: (state) => state.countries,
    getTierInfos: (state) => state.tierInfo,
    getShippingInfoCountries: (state) => state.shippingInfoCountries
  },
  mutations: {
    SET_CITIES (state, payload) {
      state.cities = payload
    },
    SET_STATE (state, payload) {
      state.states = payload
    },
    SET_COUNTRIES (state, payload) {
      state.countries = payload
    },
    SET_TIER_INFOS (state, payload) {
      state.tierInfo = payload
    },
    SET_SHIPPING_INFO_COUNTRIES (state, payload) {
      state.shippingInfoCountries = payload
    }
  },
  actions: {
    async getCitiesStatesCountries ({ commit, state }) {
      const res = await ApiUtils.postData({
        data: [
          { api: 'O0103CitiesService.getCities' },
          { api: 'O0102StatesService.getStates' },
          { api: 'O0101CountriesService.getCountries' }
        ]
      })
      commit('SET_CITIES', res[0].output)
      commit('SET_STATE', res[1].output)
      commit('SET_COUNTRIES', res[2].output)
    },
    async getTierInfos ({ commit, state }, payload) {
      const res = await ApiUtils.postData({
        data: [
          { api: 'C1101ProjectCrowdFundTierService.getTierInfos', input: payload }
        ]
      })
      commit('SET_TIER_INFOS', res[0].output)
      return res
    },
    async getShippingInfoCountries ({ commit, state }, payload) {
      const res = await ApiUtils.postData({
        data: [
          { api: 'C1101ProjectCrowdFundTierService.getShippingInfoCountries', input: payload }
        ]
      })
      if (res[0].output !== null) {
        commit('SET_SHIPPING_INFO_COUNTRIES', res[0].output.shippingPrice)
      }
    },
    async checkout ({ commit, state }, payload) {
      return await ApiUtils.postData({
        data: [
          { api: 'C1101ProjectCrowdFundTierService.checkout', input: payload }
        ]
      })
    }
  }
}

export default C1301Const.getStore(store)
